/** Utilities for dealing with Brandly API addresses
 * Oscar stores city as "line4". We convert to the more
 * conventional names at the service level, using the routines herein.
 *
 * NB "Munge" means "To perform a lossy transformation of data, for not very good reasons."
 *
 */

export function deeplyMunge(func, object) {
  if (Array.isArray(object)) return object.map(item => deeplyMunge(func, item));
  if (!object || typeof object !== 'object') return object;
  let result = func(object);
  for (let k of Object.keys(result)) {
    result[k] = deeplyMunge(func, result[k]);
  }
  return result;
}

/**
 * Ensure address follows API conventions:
 * 1. countries specified by URL
 * 2. "city" renamed to "line4"
 * 3. Remove "address_verification"
 * Returns a copy of given object. Does not apply deeply.
 * @param {*} object
 */
export function shallowToApi(object) {
  let {country, city: line4, address_verification, ...rest} = object;
  if (country && !/\//.test(country)) country = `http://www.lvh.me/services/cart/api/v1/cart/countries/${country}/`;
  return {line4, country, ...rest};
}

/**
 * Ensure address follows App conventions:
 * 1. countries specified by two digit code, not URL
 * 2. "line4" renamed to "city"
 * Returns a copy of given object. Does not apply deeply.
 * @param {*} object
 */
export function shallowFromApi(object) {
  let match, {country, line4: city, ...rest} = object;
  if (country && (match = /countries\/(..)\//.exec(country))) country = match[1];
  return {city, country, ...rest};
}

export function toApiAddressFormat(object) {
  return deeplyMunge(shallowToApi, object);
}

export function fromApiAddressFormat(object) {
  return deeplyMunge(shallowFromApi, object);
}




// WEBPACK FOOTER //
// ./src/services/mungeAddress.js